import { useCallback, useState } from "react";
import { ChevronDown, ChevronRight } from "lucide-react";
import MarkdownTextRenderer from "@/components/common-components/markdown-text-renderer/MarkdownTextRenderer";

interface ScratchPadComponentProps {
    scratchPadText: string | null;
    scratchPadActive: boolean;
    scratchPadDone: boolean;
}

const ScratchPadComponent = (props: ScratchPadComponentProps) => {
    const { scratchPadText, scratchPadActive, scratchPadDone } = props;
    
    const [isScratchPadOpen, setIsScratchPadOpen] = useState(true);

    const toggleScratchPad = useCallback(() => {
        setIsScratchPadOpen(prev => !prev);
    }, []);

    // Don't render if no scratchpad content
    if (!scratchPadText && !scratchPadActive && !scratchPadDone) {
        return null;
    }

    return (
        <div
            className={`scratch-pad-box ${scratchPadActive ? 'active' : ''} ${scratchPadDone ? 'done' : ''}`}
        >
            <div
                className="scratch-pad-header cursor-pointer flex items-center justify-between"
                onClick={toggleScratchPad}
            >
                <span className="scratch-pad-title">Scratch pad</span>

                <div className="flex items-center gap-2">
                    {scratchPadActive && (
                        <span className="scratch-pad-chip running">Generating…</span>
                    )}
                    {!scratchPadActive && scratchPadDone && (
                        <span className="scratch-pad-chip complete">Completed</span>
                    )}

                    {isScratchPadOpen ? (
                        <ChevronDown className="w-4 h-4 text-muted-ash" />
                    ) : (
                        <ChevronRight className="w-4 h-4 text-muted-ash" />
                    )}
                </div>
            </div>

            {isScratchPadOpen && scratchPadText && (
                <div className="scratch-pad-content">
                    <MarkdownTextRenderer 
                        text={scratchPadText} 
                        className="scratch-pad-text"
                    />
                </div>
            )}
        </div>
    );
};

export default ScratchPadComponent;
